import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

import { Fonts } from "assets/fonts";
import { animateColorsOnHover } from "ui/styles/style-snippets";

export const ColumnGroup = styled.colgroup`
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
`;

export const ColumnGroupTitleWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  gap: 4px;
  height: 28px;
  background-color: inherit;
`;

export const ColumnGroupTitle = styled.span`
  padding: 0 20px;
  color: ${(p) => p.theme.textMediumContrast};
  background-color: ${(p) => p.theme.bgMediumContrast};
  ${Fonts.BOLD_14}
  line-height: 28px;
`;

export const NoData = styled.p`
  margin: 32px auto;
  text-align: center;
  ${Fonts.regular_14}
  font-style: italic;
  color: ${(p) => p.theme.textLowContrast};
`;

// CELLS
export const ActionButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: 100%;
  max-width: 32px;
  background-color: transparent;
  color: ${(p) => p.theme.textLowContrast};
  border: none;
  cursor: pointer;
  visibility: hidden;
  ${animateColorsOnHover}

  &:hover {
    color: ${(p) => p.theme.textHighContrast};
  }
`;

export const ActionLink = styled(Link)`
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-width: 32px;
  color: ${(p) => p.theme.textLowContrast};
  visibility: visible;

  &:hover {
    color: ${(p) => p.theme.textHighContrast};
  }
`;

export const Cell = styled.td<{ $hidden?: boolean }>`
  height: 40px;
  padding: 0 8px;
  overflow: hidden;
  cursor: default;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${Fonts.regular_14}
  ${(p) => p.$hidden && "display: none;"};

  &:first-child {
    padding-left: 16px;
  }
  &:last-child {
    padding-right: 16px;
  }
`;

export const ActionsCell = styled(Cell)`
  padding-right: 8px;
`;

const shadowStyles = css`
  position: relative;
  box-shadow: 0 0 16px rgb(0 0 0 / 25%);
  z-index: 10;
`;
export const TableItem = styled.tr<{ $isActive?: boolean }>`
  color: ${(p) => p.theme.textHighContrast};
  ${animateColorsOnHover}
  ${(p) => p.$isActive && shadowStyles}
  ${(p) => p.onClick && "cursor: pointer;"}

  &:nth-child(2) {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  &:nth-child(odd) {
    background-color: ${(p) => p.theme.bgHighestContrast};
  }
  &:nth-child(even) {
    background-color: ${(p) => p.theme.bgHighContrast};
  }
  &:hover {
    background-color: ${(p) => p.theme.primaryLowestContrast};

    ${ActionButton}, ${ActionLink} {
      visibility: visible;
    }
  }
`;

export const TableTitle = styled.h4`
  margin: 0;
  ${Fonts.semiBold_18};
`;
